interface OrnamentProps {
    tone?: 'dark' | 'light'
    className?: string
}

export default function Ornament({ tone = 'dark', className = '' }: OrnamentProps) {
    const stroke = tone === 'light' ? 'rgba(255,255,255,0.5)' : 'var(--color-rule-strong)'
    const dot = tone === 'light' ? 'var(--color-gold-300)' : 'var(--color-gold-500)'
    return (
        <div className={`flex items-center justify-center gap-3 ${className}`} aria-hidden>
            <span style={{ width: '3rem', height: '1px', background: stroke }} />
            <span
                style={{
                    width: '6px',
                    height: '6px',
                    background: dot,
                    transform: 'rotate(45deg)'
                }}
            />
            <span style={{ width: '3rem', height: '1px', background: stroke }} />
        </div>
    )
}
